<template>
  <nav
    id="menu"
    class="pt-4 font menu no-print"
  >
    <div class="container">
      <div class="row mx-2 mr-2">
        <!-- 權限管理 -->
        <v-menu
          v-if="LoginCheck === 'true'"
          menu-mr="true"
          menu-link="/admin/account/user"
          menu-icon="user-shield"
          menu-text="帳號管理"
        />
        <!-- 收費項目 -->
        <v-menu
          v-if="LoginCheck === 'true'"
          menu-mr="true"
          menu-link="/admin/payment/review"
          menu-icon="dollar-sign"
          menu-text="收費項目管理"
        />
        <!-- 繳款項目及退費 -->
        <v-menu
          v-if="LoginCheck === 'true'"
          menu-mr="true"
          menu-link="/admin/refund/receipt_report"
          menu-icon="hand-holding-usd"
          menu-text="繳款項目及退費"
        />
        <!-- 銷帳管理及報表 -->
        <v-menu
          v-if="LoginCheck === 'true' && UserData.Privilege === '管理者'"
          menu-mr="true"
          menu-link="/admin/report/detail"
          menu-icon="chart-bar"
          menu-text="銷帳管理及報表"
        />
        <!-- OPEN API -->
        <div
          v-if="LoginCheck === 'true' && UserData.Privilege === '管理者'"
          class="col col-lg"
        >
          <v-button
            btn-type="link"
            class="identity-box identity-lia"
            @click.native="DownloadOpenApi"
          >
            <font-awesome-icon
              slot="eg"
              icon="book"
              size="3x"
            />
            <br>
            <h4
              class="menu-h4"
              slot="icon"
            >
              OPEN API規格書
            </h4>
          </v-button>
        </div>
        <!-- 登出 -->
        <v-menu
          v-if="LoginCheck === 'true'"
          menu-link="/admin/login"
          menu-icon="sign-out-alt"
          menu-text="登出"
          @click.native="logout"
        />
      </div>
    </div>
  </nav>
</template>

<script>
import vMenu from '@/components/Features/FrontMenu'
import axios from 'axios'
export default {
  data () {
    return {
      UserData: JSON.parse(sessionStorage.getItem('UserData')) ? JSON.parse(sessionStorage.getItem('UserData')) : 'false',
      LoginCheck: (sessionStorage.getItem('M_Menu') === 'true') ? 'true' : 'false'
    }
  },
  components: {
    vMenu
  },
  created () {
    const vm = this
    vm.$bus.$on('ALogOutCheckUser', (data) => {
      vm.logout(data)
    })
    vm.$bus.$on('LoginMenu', (data) => {
      vm.LoginMenus(data)
    })
  },
  methods: {
    DownloadOpenApi () { // 批次範例檔
      var Durl
      if (window.g.APIServeIP === 'http://10.201.86.159') {
        Durl = window.g.APIServeIP + ':' + window.g.Dport + '/Nuk_Dists/Template/NUK_OPENAPI_Spec.pdf'
      } else if (window.g.Dport === '85') {
        Durl = window.g.APIServeIP + ':' + window.g.Dport + '/Nuk_Dists/Template/NUK_OPENAPI_Spec.pdf'
      } else {
        Durl = window.g.APIServeIP + '/Nuk_Dists/Template/NUK_OPENAPI_Spec.pdf'
      }
      axios({
        method: 'get',
        url: Durl,
        responseType: 'arraybuffer'
      }).then(
        response => {
          this.FileDownload(response)
        }
      )
    },
    FileDownload (response) { // open api規格書
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'NUK_OPENAPI_Spec.pdf')
      document.body.appendChild(link)
      link.click()
    },
    LoginMenus () {
      this.LoginCheck = 'true'
      this.UserData = JSON.parse(sessionStorage.getItem('UserData')) ? JSON.parse(sessionStorage.getItem('UserData')) : 'false'
    },
    logout () {
      // 清除紀錄資訊
      var checked = localStorage.getItem('M_checked')
      var KeepUserId = localStorage.getItem('M_KeepUserId')
      var Version = localStorage.getItem('Version')
      // localStorage
      localStorage.clear()
      sessionStorage.clear()
      localStorage.setItem('M_checked', checked)
      localStorage.setItem('Version', Version)
      if (KeepUserId !== null) {
        localStorage.setItem('M_KeepUserId', KeepUserId)
      }
      // 判斷登出，變換帳號資訊
      this.LoginCheck = 'false'
      this.$bus.$emit('LogOutUser')
      this.$bus.$emit('messsage:push', '已登出', 'primary')
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/menu.scss';
</style>
